/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { TaskInput } from './TaskInput/TaskInput';
import { InputConfig } from './types';

export namespace TaskInputs {
  export interface Props {
    inputs: InputConfig[];
  }
}

export const TaskInputs: React.SFC<TaskInputs.Props> = ({ inputs }) => {
  return (
    <>
      {inputs.map(input => (
        <TaskInput key={input.id} config={input} />
      ))}
    </>
  );
};
